function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScheduleEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 171 171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M0 171.997V0h171.997v171.997z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.813 138.938v-85.5h135.375v85.5c0 7.87-6.38 14.25-14.25 14.25H32.063c-7.87 0-14.25-6.38-14.25-14.25",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "#bbdefb",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.188 39.188v21.374H17.813V39.189c0-7.87 6.38-14.25 14.25-14.25h106.874c7.87 0 14.25 6.38 14.25 14.25",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "#2196f3",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.25 39.188c0 5.899-4.784 10.687-10.688 10.687-5.903 0-10.687-4.788-10.687-10.688 0-5.899 4.784-10.687 10.688-10.687 5.903 0 10.687 4.788 10.687 10.688m-64.125 0c0 5.899-4.784 10.687-10.688 10.687-5.903 0-10.687-4.788-10.687-10.688 0-5.899 4.784-10.687 10.688-10.687 5.903 0 10.687 4.788 10.687 10.688",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "#1565c0",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.563 14.25a7.128 7.128 0 0 0-7.126 7.125v17.813a7.125 7.125 0 0 0 14.25 0V21.375a7.132 7.132 0 0 0-7.124-7.125m-64.126 0a7.128 7.128 0 0 0-7.124 7.125v17.813a7.125 7.125 0 0 0 14.25 0V21.375a7.132 7.132 0 0 0-7.126-7.125",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "#b0bec5",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.082 124.638h-18.8l12.8-34h-22l-12 42h17.2l-9.2 38z",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "#ffc107",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 6,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleEvent);
export default __webpack_public_path__ + "static/media/scheduleEvent.5e429efb9c047758f8e4aa2ab4318131.svg";
export { ForwardRef as ReactComponent };